import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from '@/components/ui/select';

// Campos del producto/servicio (paso 1 del formulario). Compartido entre
// ProductsPage y BrandsPage para que "crear/editar" sea EL MISMO formulario en
// ambos lados (reuso, no duplicación). No maneja guardado ni media: eso vive en
// el contenedor (la media se edita en el detalle in-place).
export default function ProductFields({ productForm, setProductForm, esCatalogo, brands }) {
  const set = (patch) => setProductForm({ ...productForm, ...patch });
  return (
    <>
      <div><Label className="text-xs">Nombre *</Label><Input value={productForm.name} onChange={e => set({ name: e.target.value })} className="bg-black/20 border-white/10 text-xs mt-1" data-testid="pp-name" /></div>
      {esCatalogo && (
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">Tipo</Label>
            <Select value={productForm.kind || 'product'} onValueChange={v => set({ kind: v })}>
              <SelectTrigger className="bg-black/20 border-white/10 text-xs mt-1" data-testid="pp-kind"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="product">Producto</SelectItem>
                <SelectItem value="service">Servicio</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label className="text-xs">Categoría</Label><Input value={productForm.category} onChange={e => set({ category: e.target.value })} className="bg-black/20 border-white/10 text-xs mt-1" placeholder="Curso, membresía..." /></div>
        </div>
      )}
      <div><Label className="text-xs">Descripción comercial</Label><Input value={productForm.description} onChange={e => set({ description: e.target.value })} className="bg-black/20 border-white/10 text-xs mt-1" /></div>
      {esCatalogo && (
        <div>
          <Label className="text-xs">Descripción para la IA</Label>
          <Textarea value={productForm.ai_description} onChange={e => set({ ai_description: e.target.value })} className="bg-black/20 border-white/10 text-xs mt-1 min-h-[80px]" placeholder="Qué debe saber la IA para contestar bien: incluye, no incluye, para quién es, cómo se vende." data-testid="pp-ai-description" />
        </div>
      )}
      {esCatalogo && (
        <div className="grid grid-cols-2 gap-2">
          <div><Label className="text-xs">Precio</Label><Input type="number" value={productForm.price} onChange={e => set({ price: e.target.value })} className="bg-black/20 border-white/10 text-xs mt-1" /></div>
          <div><Label className="text-xs">Moneda</Label><Input value={productForm.currency} onChange={e => set({ currency: e.target.value })} className="bg-black/20 border-white/10 text-xs mt-1" /></div>
        </div>
      )}
      {brands.length > 0 && (
        <div>
          <Label className="text-xs">Marca</Label>
          <Select value={productForm.brand_id || 'none'} onValueChange={v => set({ brand_id: v === 'none' ? '' : v })}>
            <SelectTrigger className="bg-black/20 border-white/10 text-xs mt-1"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="none">Sin marca</SelectItem>{brands.map(b => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
      <div className="flex items-center gap-2"><Switch checked={productForm.is_active} onCheckedChange={v => set({ is_active: v })} /><Label className="text-xs">Activo</Label></div>
    </>
  );
}
